!function (e) {
  var n = e.languages.parser = e.languages.extend("markup", {
    keyword: {
      pattern: /(^|[^^])(?:\^(?:case|eval|for|if|switch|throw)\b|@(?:BASE|CLASS|GET(?:_DEFAULT)?|OPTIONS|SET_DEFAULT|USE)\b)/,
      lookbehind: !0
    },
    variable: {
      pattern: /(^|[^^])\B\$(?:\w+|(?=[.{]))(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
      lookbehind: !0,
      inside: {
        punctuation: /\.|:+/
      }
    },
    function: {
      pattern: /(^|[^^])\B[@^]\w+(?:(?:\.|::?)\w+)*(?:\.|::?)?/,
      lookbehind: !0,
      inside: {
        keyword: {
          pattern: /(^@)(?:GET_|SET_)/,
          lookbehind: !0
        },
        punctuation: /\.|:+/
      }
    },
    escape: {
      pattern: /\^(?:[$^;@()\[\]{}"':]|#[a-f\d]*)/i,
      alias: "builtin"
    },
    punctuation: /[\[\](){};]/
  });
  n = e.languages.insertBefore("parser", "keyword", {
    "parser-comment": {
      pattern: /(\s)#.*/,
      lookbehind: !0,
      alias: "comment"
    },
    expression: {
      pattern: /(^|[^^])\((?:[^()]|\((?:[^()]|\((?:[^()])*\))*\))*\)/,
      greedy: !0,
      lookbehind: !0,
      inside: {
        string: {
          pattern: /(^|[^^])(["'])(?:(?!\2)[^^]|\^[\s\S])*\2/,
          lookbehind: !0
        },
        keyword: n.keyword,
        variable: n.variable,
        function: n.function,
        boolean: /\b(?:false|true)\b/,
        number: /\b(?:0x[a-f\d]+|\d+(?:\.\d*)?(?:e[+-]?\d+)?)\b/i,
        escape: n.escape,
        operator: /[~+*\/\\%]|!(?:\|\|?|=)?|&&?|\|\|?|==|<[<=]?|>[>=]?|-[fd]?|\b(?:def|eq|ge|gt|in|is|le|lt|ne)\b/,
        punctuation: n.punctuation
      }
    }
  }), e.languages.insertBefore("inside", "punctuation", {
    expression: n.expression,
    keyword: n.keyword,
    variable: n.variable,
    function: n.function,
    escape: n.escape,
    "parser-punctuation": {
      pattern: n.punctuation,
      alias: "punctuation"
    }
  }, n.tag.inside["attr-value"]);
}(Prism);